import { clamp } from 'lodash-es'
import { ReactNode, useState } from 'react'

export interface StepOption {
  label: string
  component: ReactNode
}

export function useStepper(steps: StepOption[]) {
  const [activeStep, setActiveStep] = useState<number>(0)

  function gotoStep(step: number) {
    const validStep = clamp(0, step, steps.length - 1)
    setActiveStep(validStep)
  }

  function renderStep() {
    return steps[activeStep].component
  }

  return { activeStep, gotoStep, renderStep }
}
